import Vue from 'vue'

export default function saveHolidays({ schoolyear_id, holidays }) {
    const proxy = process.env.VUE_APP_PROXY
    const api_uri = process.env.VUE_APP_API_URI

    let url = proxy + api_uri + "/holidays"

    return Vue.http
        .post(url, { schoolyear_id, holidays }, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json()).catch(() => { throw "Ошибка сохранения" })
}